exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-5b70a5f4] .composer-menu-area{padding:1.45rem 0 1.45rem 1.45rem;min-height:80vh;max-width:24rem;display:grid;grid-template-rows:min-content auto 2.5rem}\n", ""]);

